<template>
  <div class="container">
    <div class="step2">
      <div class="settlementWrap" v-loading="loading">
        <el-card shadow="never" class="bgF9F9F9">
          <div slot="header" class="clearfix">
            <span class="cardTitle">{{ order.model_name }}</span>
          </div>
          <div class="orderInfo">
            <div class="orderTable">
              <template v-if="order.hotel_id">
                <span>酒店名称</span>
                <span>{{ order.hotel_name }}</span>
              </template>
              <template v-if="order.scenic_id">
                <span>景区名称</span>
                <span>{{ order.scenic_name }}</span>
              </template>

              <span>产品名称</span>
              <span>{{ order.goods_name }}</span>
              <template v-if="order.model == 'hotel'">
                <template v-if="order.goods_travel_type == 0">
                  <span>入住日期</span>
                  <span>{{ order.start_date }}</span>
                  <span>离店日期</span>
                  <span>{{ order.end_date }}</span>
                </template>
                <template v-else>
                  <span>有效期</span>
                  <span>{{ order.start_date }}~{{ order.end_date }}</span>
                </template>
              </template>
              <template v-if="order.model == 'ticket' || order.model == 'package'">
                <span>游玩日期</span>
                <span v-if="order.goods_travel_type == 1">{{ order.start_date }}~{{ order.end_date }}</span>
                <span v-else>{{ order.start_date }}</span>
              </template>
              <span>购买数量</span>
              <span>{{ order.quantity }}</span>
              <span>联系人</span>
              <span>{{ order.name }}</span>
              <span>手机号</span>
              <span>{{ order.phone }}</span>
              <template v-if="order.model != 'store'">
                <span>证件号</span>
                <span>{{ order.idcard }}</span>
              </template>
              <template v-else>
                <span>提货方式</span>
                <span>{{ order.express_type_name }}</span>
                <template v-if="order.express_type == 1">
                  <span>提货地址</span>
                  <span>{{ order.fetch_address }}</span>
                </template>
                <template v-else>
                  <span>收货地址</span>
                  <span>{{ order.address_province }}-{{ order.address_city }}-{{ order.address_district }}-{{
        order.address_detail }}</span>
                </template>
              </template>
            </div>
            <div class="total">
              支付总额
              <span class="price">￥{{ order.pay_amount }}</span>
            </div>
          </div>
        </el-card>
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">选择支付方式</span>
          </div>
          <div class="payType">
            <div :class="['payTypeItem', { activePayType: payment_type == 1 }]" @click="handleChangePaymentType(1)">
              <img src="~@/assets/images/u1261.svg" alt />
              <span>微信支付</span>
              <i v-if="payment_type == 1" class="selectIcon el-icon-check"></i>
            </div>
            <div :class="['payTypeItem', { activePayType: payment_type == 2 }]" @click="handleChangePaymentType(2)">
              <img src="~@/assets/images/u1260.svg" alt />
              <span>支付宝</span>
              <i v-if="payment_type == 2" class="selectIcon el-icon-check"></i>
            </div>
          </div>
        </el-card>
      </div>
      <div class="submitOrder" @click="handlePay" v-if="order.status == 0">立即支付</div>
    </div>

    <!-- 付款二维码 -->
    <pay-qrcode :pay="pay" :visible.sync="showQrcodeForm" @success="handleSuccess" />
  </div>
</template>

<script>
import { getOrderDetail } from '@/api/order';
import { doPay } from "@/api/pay";
import PayQrcode from '@/components/payQrcode';
export default {
  name: 'OrderPay',
  components: {
    PayQrcode,
  },
  computed: {
  },
  data() {
    return {
      payment_type: 1,
      pay: {},
      showQrcodeForm: false,
      orderId: 0,
      order: {},
      loading: false,
    }
  },
  created() {
    this.orderId = this.$route.params.id || 0;
    this.getOrderDetail()
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice
  },
  methods: {
    getOrderDetail() {
      this.loading = true;
      getOrderDetail({ id: this.orderId }).then(res => {
        this.loading = false;
        this.order = res.data;
        if (res.data.pay_time) {
          this.$router.push({
            name: 'orderSuccess',
            params: {
              id: this.orderId
            }
          })
        }
        this.$store.dispatch("setModel", res.data.model);
      }).catch(() => {
        this.loading = false;
      });
    },
    handleChangePaymentType(type) {
      if (type == 2) {
        this.$message.error('暂未开放，敬请期待！');
        return false;
      }
      this.payment_type = type;
    },
    handleSuccess() {
      this.$router.push({
        name: 'orderSuccess',
        params: {
          id: this.orderId
        }
      })
    },
    // 去支付
    handlePay() {
      const _form = this.form;
      this.loading = true
      doPay({
        order_id: this.orderId,
        payment_type: this.payment_type
      }).then((res) => {
        this.loading = false;
        this.pay = res.data
        this.showQrcodeForm = true;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 50px;

  .step2 {
    width: 75.7%;
    min-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .settlementWrap {
      width: 100%;
      display: grid;
      grid-template-columns: 784fr 676fr;
      column-gap: 16px;

      .orderInfo {
        font-weight: 400;
        font-style: normal;
        font-size: 16px;
        color: #303133;
        padding: 20px 0;

        .orderTable {
          display: grid;
          grid-template-columns: 90px auto;
          column-gap: 10px;
          row-gap: 15px;

          :nth-child(odd) {
            text-align: right;
          }
        }

        .total {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 15px;
        }
      }

      .payType {
        display: flex;
        align-items: center;
        column-gap: 20px;
        justify-content: center;

        .payTypeItem {
          font-weight: 400;
          font-style: normal;
          font-size: 18px;
          color: #909399;
          text-align: center;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          align-items: center;
          padding: 39px 49px 59px 49px;
          position: relative;
          cursor: pointer;
          border: solid 2px transparent;

          .selectIcon {
            color: white;
            font-weight: bold;
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0;
            height: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid #4f99a5;
            border-bottom: 20px solid #4f99a5;
            border-top: 20px solid transparent;
          }

          img {
            width: 75px;
            height: 75px;
            object-fit: cover;
            object-position: left;
          }
        }

        .activePayType {
          border: solid 2px #4f99a5;
        }
      }
    }

    .submitOrder {
      font-weight: 500;
      font-style: normal;
      font-size: 26px;
      color: #ffffff;
      cursor: pointer;
      background-color: rgba(150, 33, 35, 1);
      text-align: center;
      padding: 25px 100px;
      box-sizing: border-box;
      width: fit-content;
      margin-top: 50px;
    }
  }

  .price {
    font-weight: 650;
    font-style: normal;
    color: #ff3d2e;
    font-size: 24px;
  }

  .cardTitle {
    font-weight: 650;
    font-style: normal;
    font-size: 22px;
    color: #000000;
  }
}
</style>
